var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.usersDevices),function(device){return _c('DeviceLink',{key:device.id,attrs:{"device":device,"type":_vm.type}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }